import { I18n } from 'aws-amplify';
import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
    multiPanelAtom,
    knowledgeViewSelectedAtom,
    listenOnChangeKnowledgeViewSelectedAtom,
    isUsingChatAIAtom
} from '@/state/atom/panelAtom';
import Constant from '@/common/constant/Constant';
import {
    drilldownDataSelectedForLog,
    publicKnowledgeHitNumberTicketAtom
} from '@/state/atom/ticketAtom';
import { userAtom } from '@/state/atom/userAtom';
import { projectInuseDetailAtom, viewKnowledgeProjectSelectedAtom } from '@/state/atom/projectAtom';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { Tooltip } from '@material-ui/core';
import { handleToggleUsingKnowledgeTicketList, handleUpdateSearchCondition } from '../handler/ChatAIHandler';
import Utils from '@/common/utils/utils';
import { destinationPrjIdAtom } from '@/state/atom/ticketKnowledgeAtom';


export default function GroupButtonKnowledge({
    API,
    projectInfo,
    panelId,
    tabId,
    resetSearchCondition,
    viewSelectedIdInProps,
    viewStructure,
    setIsLoading,
    enqueueSnackbar,
    reOpenKnowledgePanel,
    projectIdKnowledgeSelected,
    isInvalidPrecondition,
    tabNameChatAI,
    corporationSelected,
    initHitNumber,
    isUsingKnowledgeService,

    toggleUsingKnowledgeTicketList,
    setToggleUsingKnowledgeTicketList
}) {
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const isOpeningKnowledgeListPanel = panelList.some(p => p.type === Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST);

    const [viewSelectedKnowledge, setViewSelectedKnowledge] = useRecoilState(knowledgeViewSelectedAtom);
    const listenOnChangeViewSelectedKnowledge = useRecoilValue(listenOnChangeKnowledgeViewSelectedAtom);

    const drilldownDataForLog = useRecoilValue(drilldownDataSelectedForLog);
    const totalTickets = useRecoilValue(publicKnowledgeHitNumberTicketAtom);

    const userDetail = useRecoilValue(userAtom);
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    const corporationDetail = useRecoilValue(corporationAtom);
    const [isUsingChatAI, setIsUsingChatAI] = useRecoilState(isUsingChatAIAtom);

    const viewKnowledgeProjectSelected = useRecoilValue(viewKnowledgeProjectSelectedAtom);
    const destinationPrjId = useRecoilValue(destinationPrjIdAtom);

    
    const getTitleProject = () => {
        const titleProjectValue = projectIdKnowledgeSelected === Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
        ? I18n.get('CM-LABEL-ALL-KNOWLEDGE-IN-ORG')
        : projectInfo?.projectName

        return (
            <Tooltip
                title={titleProjectValue}
                placement="top"
                arrow={true}
                disableHoverListener={
                    !toggleUsingKnowledgeTicketList
                    || isInvalidPrecondition
                    || !projectIdKnowledgeSelected
                }
            >
                <p
                    className={`content-msg overFlow-lineHeight`}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    }}
                >
                    {titleProjectValue}
                </p>
            </Tooltip>
        );
    };

    useEffect(() => {
        // re-check isUsingChatAI
        if (!isOpeningKnowledgeListPanel) {
            (
                async () => await Utils.isUsingFunctionService(
                    viewKnowledgeProjectSelected,
                    corporationDetail,
                    'usingChatAI',
                    setIsUsingChatAI
                )
            ) ()
        }

    }, [isOpeningKnowledgeListPanel]);

    return (
        <div className="group-button-chat-ai-container">
            <div className="left">
                <div className="d-flex align-items-center justify-content-center gap-8">
                    <Tooltip
                        title="参照ナレッジ一覧"
                        placement="bottom"
                        arrow={true}
                        disableHoverListener={
                            !toggleUsingKnowledgeTicketList
                            || isInvalidPrecondition
                            || !projectIdKnowledgeSelected
                            || !isUsingKnowledgeService
                        }
                    >
                        <img
                            src={`/assets/image/icon-knowledge-chat-ai-${
                                (!toggleUsingKnowledgeTicketList || isInvalidPrecondition || !isUsingKnowledgeService  || !projectIdKnowledgeSelected)
                                    ? 'disable'
                                    : 'enable'
                            }.svg`}
                            alt="icon"
                            onClick={reOpenKnowledgePanel}
                            className={`icon-knowledge-chat-ai ${
                                !toggleUsingKnowledgeTicketList || isInvalidPrecondition || !isUsingKnowledgeService  || !projectIdKnowledgeSelected
                                    ? 'disabled-event'
                                    : ''
                            }`}
                        />
                    </Tooltip>
                    {(!isInvalidPrecondition && toggleUsingKnowledgeTicketList && isUsingKnowledgeService && projectIdKnowledgeSelected) && (
                        getTitleProject()
                    )}
                </div>
            </div>

            <div className="group-btn-submit-reset">

                {/* Toggle usingKnowledgeTicketList  */}
                <div className={`reference-SolutionDesk-Of-Knowledge-Ticket ${!isUsingKnowledgeService && 'hidden'}`}>
                    <p className='reference-knowledge-title'>SolutionDesk内のナレッジを参照</p>
                    <div className="switch-check">
                        <input
                            type="checkbox"
                            id={`switch-referenceSolutionDeskOfKnowledgeTicket-mode`}
                            checked={toggleUsingKnowledgeTicketList}
                            value={toggleUsingKnowledgeTicketList}
                            onChange={() => handleToggleUsingKnowledgeTicketList(
                                API,
                                panelId,
                                tabId,
                                panelList,
                                setPanelList,

                                viewSelectedKnowledge,
                                drilldownDataForLog,
                                totalTickets,

                                userDetail,
                                projectInuseDetail,
                                corporationDetail,

                                tabNameChatAI,
                                corporationSelected,
                                projectIdKnowledgeSelected,
                                toggleUsingKnowledgeTicketList,
                                setToggleUsingKnowledgeTicketList,
                                initHitNumber
                            )}
                        />
                        <label htmlFor={`switch-referenceSolutionDeskOfKnowledgeTicket-mode`}></label>
                    </div>
                </div>

                {/* btn reload ViewSelectedKnowledge */}
                <Tooltip
                    title={I18n.get('LABEL-TOOLTIP-BUTTON-SAVE-SEARCH-CONDITION')}
                    arrow={true}
                    disableHoverListener={
                        !isOpeningKnowledgeListPanel
                        || Utils.isEmptyObject(viewSelectedKnowledge)
                        || !isUsingKnowledgeService
                    }
                >
                    <div className={
                            `d-flex align-items-center justify-content-center gap-8 ${
                                (!toggleUsingKnowledgeTicketList || !isUsingKnowledgeService) && 'hidden'
                            }`
                        }
                    >
                        <img
                            src={`/assets/image/icon-reload.svg`}
                            alt="icon"
                            onClick={() => handleUpdateSearchCondition(
                                setViewSelectedKnowledge,
                                listenOnChangeViewSelectedKnowledge,
                                
                                panelList, 
                                setPanelList, 
                                panelId, 
                                tabId,
                                enqueueSnackbar,
                                viewKnowledgeProjectSelected,
                                API,
                                viewSelectedKnowledge,
                                drilldownDataForLog,
                                totalTickets,
                                userDetail,
                                projectInuseDetail,
                                corporationDetail,
                                tabNameChatAI,
                                corporationSelected,
                                projectIdKnowledgeSelected,
                                isUsingChatAI,
                                destinationPrjId
                            )}
                            className={`icon-reload ${
                                !isOpeningKnowledgeListPanel || Utils.isEmptyObject(viewSelectedKnowledge)
                                    ? 'disabled-event'
                                    : ''
                            }`}
                        />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
